import React, { useState, useEffect } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';

import { withStyles } from '@material-ui/core';

import Dashboard from '../../../../../layouts/Dashboard';

import { selectLocationOrdersInitQuery, Location } from './queries';

import styles from './styles';
import LocationOrders from '../../../../../components/Global/LocationOrders';
import { useQuery } from '@apollo/client';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
  location_id: string;
}

const ViewLocationOrders = ({ classes, history }: Props): React.ReactElement => {
  const { organisation_id, location_id } = useParams<UrlParams>();

  const [location, setLocation] = useState<Location>({
    name: '',
    organisation: {
      name: '',
    },
  });

  const { data: locationOrdersInitData } = useQuery(selectLocationOrdersInitQuery(location_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && locationOrdersInitData) {
      setLocation(locationOrdersInitData.locations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [locationOrdersInitData]);

  return (
    <Dashboard
      breadcrumbs={[
        { label: 'Organisations', link: '/admin/organisations' },
        { label: location.organisation.name, link: `/admin/organisations/${organisation_id}` },
        { label: 'Locations', link: `/admin/organisations/${organisation_id}/locations` },
        { label: location.name, link: `/admin/organisations/${organisation_id}/locations/${location_id}` },
        { label: 'Orders' },
      ]}>
      <LocationOrders location_id={location_id} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ViewLocationOrders));
